import { createClient } from '@supabase/supabase-js'
import config from '@/config/config.env'

const supabaseUrl = config.supabaseConfig.url
const supabaseAnonKey = config.supabaseConfig.anonKey

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided in environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // INDUSTRY-BEST: Use native navigator.locks for cross-tab token refresh safety.
    // This prevents concurrent token refreshes across tabs from invalidating
    // each other's refresh tokens — the root cause of "random logouts".
    // Previously disabled with a no-op, which caused session corruption.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: globalThis.localStorage,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})
